module.exports = __webpack_public_path__ + "static/media/guadalajara.01b524ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/centers/guadalajara.png
// module id = 617
// module chunks = 0